import { Link } from "react-router-dom";
import { ShieldCheck, Mail } from "lucide-react";
import { FOOTER_GROUPS, CLIENT_LINE, OFFICIAL_EMAIL } from "@/lib/content";
import Logo from "@/components/Logo";
import { OPEN_PREFS_EVENT } from "@/components/CookieConsent";

export default function Footer() {
  return (
    <footer className="border-t border-[#E2E8F0] bg-white" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-5 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo className="text-3xl" />
            <p className="mt-3 text-sm text-[#64748B] leading-relaxed max-w-xs">{CLIENT_LINE}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-[#64748B]">
              <ShieldCheck className="w-4 h-4 text-[#3157F6]" strokeWidth={1.9} /> Indipendente per davvero
            </span>
            <a href={`mailto:${OFFICIAL_EMAIL}`} data-testid="footer-email"
              className="mt-3 flex items-center gap-1.5 text-sm text-[#334155] hover:text-[#3157F6] transition-colors">
              <Mail className="w-4 h-4" strokeWidth={1.9} /> {OFFICIAL_EMAIL}
            </a>
          </div>
          {FOOTER_GROUPS.map((g) => (
            <div key={g.title}>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-[#64748B] mb-4">{g.title}</h3>
              <ul className="space-y-3">
                {g.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-${l.to.replace(/\//g, "")}`}
                      className="text-sm text-[#334155] hover:text-[#3157F6] transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-[#E2E8F0] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-[#64748B]">© {new Date().getFullYear()} OKKIO. Analisi indipendente a scopo informativo. Non sostituisce una perizia professionale.</p>
          <div className="flex items-center gap-4">
            <button type="button" data-testid="footer-manage-cookies"
              onClick={() => window.dispatchEvent(new Event(OPEN_PREFS_EVENT))}
              className="text-xs font-semibold text-[#334155] hover:text-[#3157F6] transition-colors underline underline-offset-2">
              Gestisci preferenze cookie
            </button>
            <p className="text-xs text-[#64748B]">OKKIO non è un’impresa edile.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
